import { Table, Space, Card } from 'antd';
import { userdata } from '../typing/table_typing';
import { Component } from 'react';
import { cardmargin, grayheader } from '../../CSSReferences';
import { Link } from 'react-router-dom';
import { licenceLine, TenantLicence } from '../typing/licence_summary';

export interface TableThingyMainProps{
  data:{
    user:userdata[],
  }
  onLoadRequested:()=>void;
}

interface TableThinyViewInnerState{filteredInfo:any, sortedInfo:any}

export class TableThingyView extends Component<TableThingyMainProps, TableThinyViewInnerState> 
{
    constructor(props:TableThingyMainProps){
      super(props);
      this.state = {
        filteredInfo: null,
        sortedInfo: null,
      };
    }

    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 2000);
      
      // this.props.onButtonClicked();
    }

    data = this.props.data;
    
    handleChange = (pagination:any, filters:any, sorter:any) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    
      clearFilters = () => {
        this.setState({
        filteredInfo: null,
      });
      };
    
      clearAll = () => {
        this.setState({
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'age',
          },
        });
      };
    

render(){
  let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'uuid',
        sorter: (a:any, b:any) => a.name.length - b.name.length,
        sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Contact',
        dataIndex: 'uuid',
        key: 'uuid',
        sorter: (a:any, b:any) => a.uuid - b.uuid,
        sortOrder: sortedInfo.columnKey === 'uuid' && sortedInfo.order,
        ellipsis: true,
        render: (type:any, b:any) => {
          return(
            <div>
            {b.contactList}
            </div>
          )
          },
      },
      {
        title: 'Customer',
        dataIndex: 'customerlist',
        key: 'uuid',
        sorter: (a:any, b:any) => a.customerlist.length - b.customerlist.length,
        sortOrder: sortedInfo.columnKey === 'email' && sortedInfo.order,
        ellipsis: true,
        render: (type:any, b:any) => {
          return(
            <div>
            {b.customer}
            </div>
          )
          },
      },
      {
        // Self-service tenants have no contact; their licences say which installation they are (anima_core#11).
        title: 'Licences',
        dataIndex: 'licences',
        key: 'licences',
        render: (licences: TenantLicence[] | undefined) => (
          <div>
            {(licences ?? []).map(licence => (
              <div key={licence.uuid}><Link to={"/license/" + licence.uuid}>{licenceLine(licence)}</Link></div>
            ))}
          </div>
        ),
      },
    ];

    
  return (
    <div>
      <Card title="Client List" style={cardmargin}  hoverable styles={{ header: grayheader }}>
    <Space style={{ marginBottom: 16 }}>
      {/* <Button onClick={this.setAgeSort}>Sort age</Button>
      <Button onClick={this.clearFilters}>Clear filters</Button>
      <Button onClick={this.clearAll}>Clear filters and sorters</Button> */}
    </Space>
    <Table columns={columns} dataSource={this.props.data.user} onChange={this.handleChange} />
    </Card>
    </div>
  )}
}